/**
 * Where the map engine lives (MapLibre plan D2). This is the only runtime
 * mention of it.
 *
 * The engine, the shared module it imports and its module worker are
 * committed byte-for-byte under `public/maplibre/<version>/`, each with a
 * `.gz` and a `.br` sibling (`scripts/sync-maplibre.js` writes all nine). CRA
 * copies `public/` into `build/`, and the server serves `build/` at the site
 * root, so every file is a same-origin URL: the engine is a module script
 * under `script-src 'self'`, the worker is under `worker-src 'self'` — never a
 * `blob:`. The browser loads the engine as a native ES module
 * (`engineImport.ts`); webpack never parses it.
 *
 * The URLs are plain strings on purpose: CRA's babel-jest cannot parse the
 * module-URL meta-property, and `frontend/src` must not name it (plan D2).
 *
 * A version bump is three edits kept in lockstep by `mapEngine.test.ts`:
 * `package.json`, `MAPLIBRE_VERSION`, and a re-run of the sync script.
 */
export const MAPLIBRE_VERSION = '6.11.2';

/** The three files the engine needs, side by side. */
export const ENGINE_FILES = [
  'maplibre-gl.mjs',
  'maplibre-gl-shared.mjs',
  'maplibre-gl-worker.mjs',
] as const;

export const engineUrl = (): string => `/maplibre/${MAPLIBRE_VERSION}/maplibre-gl.mjs`;

export const workerUrl = (): string => `/maplibre/${MAPLIBRE_VERSION}/maplibre-gl-worker.mjs`;
